import React from 'react';

const ContactUs = () => {
  const phoneNumber = '+919423886986';
  const email = 'support@vakralabs.com';

  const handleCall = () => {
    window.open(`tel:${phoneNumber}`);
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber.replace('+', '')}`);
  };

  const handleEmail = () => {
    window.open(`mailto:${email}`);
  };

  return (
    <div
      className="py-5"
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e0f7fa 0%, #fff 100%)',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <h1 className="fw-bold text-teal mb-3" style={{ letterSpacing: 1 }}>Get in Touch with Vakralabs</h1>
          <p className="lead text-secondary">
            We’re here to help you with your digital transformation journey.<br />
            Reach out for product demos, partnership opportunities, or just to say hello!
          </p>
        </div>
        <div className="row justify-content-center align-items-start">
          {/* Address Card */}
          <div className="col-md-4 mb-4">
            <div
              className="card shadow border-info h-100"
              style={{
                background: 'rgba(255,255,255,0.95)',
                borderRadius: 18,
                borderWidth: 2,
              }}
            >
              <div className="card-body">
                <h5 className="card-title text-info mb-3">Our Address</h5>
                <address style={{ fontSize: '1.1em', fontWeight: 500 }}>
                  <strong>Vakralabs Services</strong><br />
                  C-902, Bhalchandra Akashvan,<br />
                  Punawale, Pimpri-Chinchwad,<br />
                  Pune, Maharashtra - 411033<br />
                  <span className="text-muted">India</span>
                </address>
              </div>
            </div>
          </div>
          {/* Contact Card */}
          <div className="col-md-5 mb-4">
            <div
              className="card shadow h-100"
              style={{
                background: 'rgba(236, 253, 245, 0.97)',
                borderRadius: 18,
                border: '1.5px solid #009688',
              }}
            >
              <div className="card-body text-center">
                <h2 className="mb-4 text-teal">Contact Us</h2>
                <p className="mb-4 text-muted">
                  We'd love to hear from you!<br />
                  Reach out to us via phone, WhatsApp, or email.
                </p>
                <div className="d-grid gap-3">
                  <button
                    className="btn btn-success btn-lg"
                    onClick={handleCall}
                  >
                    📞 Call Us<br />
                    <small>{phoneNumber.replace('+91', '+91 ')}</small>
                  </button>
                  <button
                    className="btn btn-success btn-lg"
                    onClick={handleWhatsApp}
                  >
                    💬 WhatsApp<br />
                    <small>{phoneNumber.replace('+91', '+91 ')}</small>
                  </button>
                  <button
                    className="btn btn-teal btn-lg"
                    onClick={handleEmail}
                  >
                    ✉️ Email Us<br />
                    <small>{email}</small>
                  </button>
                </div>
                <div className="mt-4">
                  <span className="badge bg-info text-dark px-3 py-2" style={{ fontSize: '1em' }}>
                    Response Time: <b>Within 24 hours</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mt-5">
          <h5 className="text-secondary">We value your feedback and queries. Let’s build something great together!</h5>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;